import React from "react"
import ScheduleList from "../../../components/schedule/schedule_list/ScheduleList"
import { EScheduleListType } from "../../../models"

interface IProps {
}

const MasterSchedules: React.SFC<IProps> = (props: IProps) => {
	return (
		<ScheduleList
			type={EScheduleListType.Master}
		/>
	)
}

export default MasterSchedules